'use strict';

var container;
var camera, scene, renderer;
var group;
var geometry;
var globeTexture;

var pause = false;

// Polyfill log 2 for IE11.
Math.log2 = Math.log2 || function (x) {
	return Math.log(x) * Math.LOG2E;
};

document.addEventListener('DOMContentLoaded', function () {
	init();
	animate();
});

function init() {
	['click', 'keypress'].forEach(function (event) {
		document.querySelector('#globePause').addEventListener(event, function (e) {
			e.preventDefault();
			if (e.type === 'click' || e.keyCode === 0 || e.keyCode === 32 || e.keyCode === 13) {
				pause = !pause;
			}
			document.querySelector('#globePause').innerText = pause ? 'Unpause' : 'Pause';
			if (typeof window.announce !== 'undefined') {
				announce.updateText(pause ? 'Rotation Paused ' : 'Rotation Un-Paused', 'polite');
			}
		});
	});

	container = document.getElementById('container');
	camera = new THREE.PerspectiveCamera(45, container.offsetWidth / container.offsetHeight, 1, 5000);
	camera.position.z = 1000;
	scene = new THREE.Scene();
	group = new THREE.Group();
	scene.rotation.x = 0.2;
	scene.rotation.z = 0.3;
	scene.add(group);

	var loader = new THREE.TextureLoader();
	loader.load(globeTexture, function (texture) {
		geometry = new THREE.SphereGeometry(600, 30, 30);
		var material = new THREE.MeshBasicMaterial({ map: texture, overdraw: 0.5 });
		var globeMesh = new THREE.Mesh(geometry, material);
		group.add(globeMesh);
	});

	renderer = new THREE.WebGLRenderer({ alpha: true });
	renderer.setPixelRatio(window.devicePixelRatio);
	renderer.setSize(container.offsetWidth, container.offsetHeight);
	container.appendChild(renderer.domElement);
}

function animate() {
	requestAnimationFrame(animate);
	render();
}

function render() {
	var canvas = renderer.domElement;
	var width = container.clientWidth;
	var height = document.querySelector('.globeContent').clientHeight - 20;

	camera.aspect = width / height;
	camera.updateProjectionMatrix();
	renderer.setSize(width, height);

	camera.position.z = Math.max(600 / Math.min(width, height) * 1800, 1800);
	if (!pause) {
		group.rotation.y -= 0.005;
	}
	renderer.render(scene, camera);
}

function loadTexture(t) {
	var value = t.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, '\'');

	globeTexture = value;
}